import React, {FC} from 'react'

import {Container as MuiContainer, Theme} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

type Props = {
  children: React.ReactNode
}

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    padding: `0 ${theme.spacing(3)}`,
    [theme.breakpoints.down('sm')]: {
      padding: `0 ${theme.spacing(2)}`,
    },
  },
}))

const ResponsiveContainer: FC<Props> = ({children}) => {
  const {classes} = useStyles()
  return (
    <MuiContainer maxWidth={'xl'} className={classes.container}>
      <>{children}</>
    </MuiContainer>
  )
}

export {ResponsiveContainer}
